/**
 * Build-time configuration.
 *
 * Everything reachable here is compiled into a public bundle. The Jeabs token
 * and the Supabase service-role key are deliberately absent and must never be
 * added (spec section 67): the browser talks only to our own Worker, which
 * holds those secrets server-side.
 */

import { tr } from '../i18n';

function required(name: string, value: string | undefined): string {
  const trimmed = value?.trim();
  if (!trimmed) {
    throw new Error(tr().config.missing(name));
  }
  return trimmed;
}

export type AppConfig = {
  apiBaseUrl: string;
  supabaseUrl: string;
  supabaseAnonKey: string;
  useDevFixtures: boolean;
};

/**
 * Reads config eagerly so a misconfigured deployment fails at startup with a
 * readable message rather than as a confusing 401 on the first query.
 */
export function readConfig(): AppConfig {
  const env = import.meta.env;
  return {
    apiBaseUrl: required('VITE_API_BASE_URL', env.VITE_API_BASE_URL).replace(/\/+$/, ''),
    supabaseUrl: required('VITE_SUPABASE_URL', env.VITE_SUPABASE_URL),
    supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', env.VITE_SUPABASE_ANON_KEY),
    // `import.meta.env.DEV` is statically false in a production build, so the
    // whole fixture branch (and its import) is dropped by the bundler.
    useDevFixtures: import.meta.env.DEV && env.VITE_USE_DEV_FIXTURES === 'true',
  };
}
